module.exports = __webpack_public_path__ + "static/media/polaroid-9.37afc2ac.png";